import {
  FormBody,
  FormFieldsContainer,
  FormInlineNotifications,
  useFormValidationErrorsNotification,
} from '../../../../../../Form'
import {
  HouseholdSizeField,
  MoveInField,
} from '../../../../../../RentalPortalApplicant'
import { useRentalPortalProfileBlockFormActions } from '../../../../../RentalPortal.hooks'

import * as styles from './ApplicantMatchingWidgetFormFields.module.css'

function ApplicantMatchingWidgetFormFields({
  isCloseConfirm,
  notifications,
  onCancel,
  onRemoveNotification,
  onSetNotification,
}) {
  const { actionsProps } = useRentalPortalProfileBlockFormActions({
    isCloseConfirm,
    onCancel,
  })

  useFormValidationErrorsNotification({
    onRemoveNotification,
    onSetNotification,
  })

  return (
    <FormBody
      actionsProps={actionsProps}
      className={styles.ApplicantMatchingWidgetFormFields}
    >
      <FormInlineNotifications notifications={notifications} />
      <FormFieldsContainer className={styles.fields}>
        <MoveInField />
        <HouseholdSizeField />
      </FormFieldsContainer>
    </FormBody>
  )
}

export default ApplicantMatchingWidgetFormFields
